// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResouse  from 'vue-resource'
import axios from 'axios';
import wx from 'weixin-js-sdk'
Vue.prototype.$axios=axios
import qs from 'qs';
Vue.prototype.$qs=qs
Vue.prototype.host='http://www.dking.store'
Vue.config.productionTip = false
Vue.use(VueResouse)
/* eslint-disable no-new */
Vue.filter('time',function(input){
	 var d = new Date(input*1000);
     var year = d.getFullYear();
     var month = d.getMonth() + 1;
     if(month<10){
      month='0'+month
     }
     var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
     var hour = d.getHours();
     var minutes = d.getMinutes();
     var seconds = d.getSeconds();
     return  year+ '-' + month + '-' + day ;
});
new Vue({
  el: '#app',
  data(){
    return{
      domain:'http://dking.vapps.me/',
      parent:[]
    }
  },
  router,
  template: '<App/>',
  components: { App },
  methods:{
    getconfig:function(title,desc){
      this.$http.get('http://eydt.vapps.me/index.php?g=Index&m=Index&a=getconfig&ref='+encodeURIComponent(window.location.href.split('#')[0])).then(response => {
           console.log(response)
           //console.log(this.jssdk)
           this.jssdk = response.body.apilist
           wx.config({
            debug: false,
            appId: this.jssdk.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
            timestamp:this.jssdk.timestamp, // 必填，生成签名的时间戳
            nonceStr: this.jssdk.noncestr, // 必填，生成签名的随机串
            signature: this.jssdk.str,// 必填，签名，见附录1
            //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
            jsApiList: [
             'onMenuShareAppMessage','onMenuShareTimeline'
            ]
          });
      })
      var that = this
      var title = title
      if(!desc){
        desc='AI、智能制造、RPA、区块链纷至沓来。安永打造“数字科技”平台，助你鏖战数字化世界。'
      }
/*      var desc = desc*/
      /*alert(window.location.href)*/
      wx.ready(function(){
          wx.onMenuShareTimeline({
              title: title, // 分享标题
              desc: desc, // 分享描述
              imgUrl: 'http://eydt.vapps.me/static/images/wx.jpg', // 分享图标
              link:window.location.href
          });

          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            imgUrl: 'http://eydt.vapps.me/static/images/wx.jpg', // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '' ,// 如果type是music或video，则要提供数据链接，默认为空
            link:window.location.href
        });
      });
    },
  }
})




// WEBPACK FOOTER //
// ./src/main.js